export default {
    BUILDING_CONSTRUCTION: 'wwfort_entered_foundation_state',
    BUILDING_UPGRADED: 'wwfort_upgrade_building',
    BUILDING_CLICK: 'wwbuilding_click',
    BUTTON_CLICK: 'wwyes_01',
    CANCEL_CLICK: 'wwselect_radial_button',
    CAROUSEL_HOVER: 'wwcarousel_01',
    CAROUSEL_CLICK: 'wwcarousel_02',
    CLICK: 'wwplay_01',
    HOVER: 'wwhighlight_02',
    MODERNIZATION_HOVER: 'wwhighlight_02', // TODO: replace with original sound when it's ready
    MODERNIZATION_CLICK: 'wwplay_01', // TODO: replace with original sound when it's ready
    RESERVE_ACTIVATION: 'wwactivate_requisition',
    RESERVE_PRODUCE_START: 'wwfort_order_inprogress',
    RESERVE_PRODUCE_SUCCESS: 'wwfort_order_isready',
    SELECT_CLICK: 'wwyes1',
    SELECT_BATTLE_CLICK: 'wwtransport_approve',
    TAB_CLICK: 'wwtabb',

    // ClanLanding sound ids
    MAIN_CARD_ENTER: 'main_unit_enter',
    MAIN_CARD_EXIT: 'main_unit_exit',
    ANNOUNCEMENT_ENTER: 'ads_enter',
    ANNOUNCEMENT_EXIT: 'ads_exit',
    STRONGHOLD_ENTER: 'fa_enter',
    STRONGHOLD_EXIT: 'fa_exit',
    GLOBAL_MAP_ENTER: 'global_map_enter',
    GLOBAL_MAP_EXIT: 'global_map_exit',
    CLANS_WINNER_REWARD_ENTER: 'clans_winner_reward_enter',
    CLANS_WINNER_REWARD_EXIT: 'clans_winner_reward_exit',
    CLANS_WINNER_REWARD_MAKE_BET: 'clans_winner_reward_make_bet',
    CONGRATULATION_CLAN_JOINING: 'gui_clans_joining_award',
    CLANS_BATTLES_GLOBAL_MAP_ENTER: 'clans_battles_global_map_enter',
    CLANS_BATTLES_GLOBAL_MAP_EXIT: 'clans_battles_global_map_exit',

    LANDING_STATE: {
        name: 'STATE_hp_clans_inside',
        enterLanding: 'STATE_hp_clans_inside_main',
        enterMainCard: 'STATE_hp_clans_inside_main_unit',
        enterStronghold: 'STATE_hp_clans_inside_fortarea',
        enterGlobalMap: 'STATE_hp_clans_inside_global_map',
        enterAnnouncements: 'STATE_hp_clans_inside_ads',
    },
}



// WEBPACK FOOTER //
// ./sounds.js